import React from 'react'
import { Row, Col, Space, Form, Input, Select, Button, Table, AutoComplete, message } from 'antd'
import { reqeGwasChrInfo, reqSearcheGwas } from '../../api'

const { Option } = Select

class SearcheGwas extends React.Component {
    state = {
        // form 表单状态
        genome: 'Lycopersicon esculentum',
        geneid: '',
        loc_chr: '',
        chr_options: '',
        loc_start: '',
        loc_end: '',
        pvalue_start: '',
        pvalue_end: '',
        disabled: false,    // 控制submit按钮的可用状态
        // 结果table状态 
        title: '',
        loading: false,
        has_data: false,
        searchResult: '',
        pagination: {
            current: '',
            pageSize: '',
            total: '',
            showSizeChanger: false,
            showQuickJumper: true
        }
    }
    
    formRef = React.createRef()

    onFinish = async (values) => {
        const { genome, loc_chr, loc_start, loc_end, tss_start, tss_end, beta_value_start, beta_value_end, pvalue_start, pvalue_end } = values
        let { geneid } = values
        if (geneid) {
            geneid = geneid.toLowerCase()
        }
        
        this.setState({
            disabled: true,
            loading: true
        })

        const param = {
            cotton_search_type: 'search_egwas',
            genome: genome,
            geneid: geneid,
            loc_chr: loc_chr,
            loc_start__gte: loc_start,
            loc_end__lt: loc_end,
            tss_distance__gte: tss_start,
            tss_distance__lt: tss_end,
            beta_value__gte: beta_value_start,
            beta_value__lt: beta_value_end,
            pvalue__gte: pvalue_start,
            pvalue__lt: pvalue_end,
            page: 1
        }
        const searchResult = await reqSearcheGwas(param)
        let table_title = ''
        if (searchResult.code === 0) {
            table_title = () => {
                return <span><b>{searchResult.data.count}</b> records were returned.</span>
            }

            this.setState({
                geneid: geneid,
                loc_chr: loc_chr,
                loc_start: loc_start,
                loc_end: loc_end,
                tss_start: tss_start,
                tss_end: tss_end,
                beta_value_start: beta_value_start,
                beta_value_end: beta_value_end,
                pvalue_start: pvalue_start,
                pvalue_end: pvalue_end,
                disabled: false,
                title: table_title,
                loading: false,
                has_data: true,
                searchResult: searchResult.data,
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    onGenomeChange = async (val) => {
        if (val != '') {
            const results = await reqeGwasChrInfo(val)
            let chr_options = ''
            if (results.code === 0) {
                let data = results.data
                for (let v of data) {
                    v['value'] = v['chr']
                    v['label'] = v['chr']
                }
                chr_options = data

                this.setState({
                    genome: val,
                    chr_options: chr_options
                })
            }
        }
    }

    //分页、排序、筛选变化时触发
    onTableChange = async (pagination, filters, sorter) => {
        const { genome, loc_chr, loc_start, loc_end, tss_start, tss_end, beta_value_start, beta_value_end, pvalue_start, pvalue_end } = this.state
        let { geneid } = this.state
        if (geneid) {
            geneid = geneid.toLowerCase()
        }

        const { current } = pagination
        const param = {
            cotton_search_type: 'search_egwas',
            genome: genome,
            geneid: geneid,
            loc_chr: loc_chr,
            loc_start__gte: loc_start,
            loc_end__lt: loc_end,
            tss_distance__gte: tss_start,
            tss_distance__lt: tss_end,
            beta_value__gte: beta_value_start,
            beta_value__lt: beta_value_end,
            pvalue__gte: pvalue_start,
            pvalue__lt: pvalue_end,
            page: current
        }
        const searchResult = await reqSearcheGwas(param)
        if (searchResult.code === 0) {
            this.setState({
                searchResult: searchResult.data,
                pagination: {
                    current: current,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    // 表单重置
    onReset = () => {
        this.formRef.current.resetFields()
        this.setState({
            trait_options: [],
            variant_options: [],
            chr_options: []
        })
    }

    async componentDidMount() {
        const { genome } = this.state
        let chr_results = await reqeGwasChrInfo(genome)
        let chr_options = ''
        if (chr_results.code === 0) {
            let data = chr_results.data
            for (let v of data) {
                v['value'] = v['loc_chr']
                v['label'] = v['loc_chr']
            }
            chr_options = data

            this.setState({
                chr_options: chr_options
            })
        }
    }

    render() {
        const { chr_options, disabled, title, loading, has_data, searchResult, pagination } = this.state
        
        const layout = {
            labelCol: { span: 3 },
            wrapperCol: { span: 6 },
            colon: false
        }
        const tailLayout = {
            wrapperCol: { offset: 3, span: 12 },
        }

        const columns = [
            {
                title: 'Genome',
                dataIndex: 'genome',
            },
            {
                title: 'Gene ID',
                dataIndex: 'geneid',
            },
            {
                title: 'Chr',
                dataIndex: 'loc_chr',
            },
            {
                title: 'start',
                dataIndex: 'loc_start',
            },
            {
                title: 'end',
                dataIndex: 'loc_end',
            },
            {
                title: 'strand',
                dataIndex: 'strand',
            },
            {
                title: 'locus',
                dataIndex: 'locus',
            },
            {
                title: 'TSS Distance',
                dataIndex: 'tss_distance',
                sorter: (a, b) => a.tss_distance - b.tss_distance,
                sortDirections: ['ascend', 'descend'],
            },
            {
                title: 'beta-value',
                dataIndex: 'beta_value',
                sorter: (a, b) => a.beta_value - b.beta_value,
                sortDirections: ['ascend', 'descend'],
            },
            {
                title: 'p-value(-log10)',
                dataIndex: 'pvalue',
            },
        ]

        if (searchResult) {
            for (let v of searchResult.results){
                v['key'] = v['geneid'] + '-' + v['locus']
            }
        }

        return (
            <React.Fragment>
                <Form {...layout} name="search-egwas" labelAlign="left" ref={this.formRef} className="search-egwas-form" onFinish={this.onFinish} initialValues={{genome: 'Lycopersicon esculentum'}}>
                    <Form.Item name="genome" label="Genome" rules={[{ required: true }]}>
                        <Select placeholder="Select genome" showArrow allowClear onChange={this.onGenomeChange}>
                            <Option value="Lycopersicon esculentum">Lycopersicon esculentum</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="geneid" label="Gene">
                        <Input placeholder="e.g. Sopim_BGV006775_03T001977.1" />
                    </Form.Item>
                    <Form.Item label="Chromosome" wrapperCol={{span: 18}}>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="loc_chr">
                                            <AutoComplete 
                                                allowClear
                                                style={{width: 150}}
                                                options={chr_options}
                                                filterOption={(inputValue, option) =>
                                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                           />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_end" label="and" 
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item label="TSS Distance" wrapperCol={{span: 18}}>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="tss_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="tss_end" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item label="Beta value" wrapperCol={{span: 18}}>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="beta_value_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^(\-|\+)?\d+(\.\d+)?$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="beta_value_end" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^(\-|\+)?\d+(\.\d+)?$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item label="P-value(-log10)" wrapperCol={{span: 18}}>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="pvalue_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^(\-|\+)?\d+(\.\d+)?$/,
                                                    message: 'must be a number or float.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="pvalue_end" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^(\-|\+)?\d+(\.\d+)?$/,
                                                    message: 'must be a number or float.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Submit
                                    </Button>
                                    <Button htmlType="button" disabled={disabled} onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <Table bordered title={title} loading={loading} has_data={has_data} columns={columns} dataSource={searchResult.results} size="middle" sticky={true} pagination={pagination} onChange={this.onTableChange} className="search-result-table" />
            </React.Fragment>
        )
    }
}

export default SearcheGwas
